import {
  call,
  put,
  takeLatest,
  delay,
  all,
  fork,
  join,
} from 'redux-saga/effects';
import { authenticationWrapper } from '@services/errorHandlingService';
import {
  sendDismissActivity,
  getPageData,
  getHistoryFromHours,
  getSessionIdV2,
} from './services';
import {
  Types,
  setPendingDashboardData,
  dismissActivityComplete,
  setHistoryFromHours,
  setChatSessionIdV2,
  chatSessionOpenedV2,
} from './actions';
import { openPopUp } from '@containers/App/containers/PopUp/actions';
import POPUP_TYPES from '@containers/App/containers/PopUp/types';
import { pageData } from './__fixtures__';

const useFixtures = process.env.USE_FIXTURES;

export function* callsetPendingDashboardData(action) {
  yield authenticationWrapper(function* codeBlock() {
    if (useFixtures) {
      yield delay(1000);
    }
    const { hours } = action.payload;
    const res = yield fork(getPageData, hours);
    const payload = useFixtures ? pageData : yield join(res);
    yield put(setPendingDashboardData(payload));
  });
}

export function* callDismissActivity(action) {
  yield authenticationWrapper(function* codeBlock() {
    if (useFixtures) {
      yield delay(500);
    }
    const { activity, reason } = action.payload;

    yield call(sendDismissActivity, activity, reason);
    yield put(dismissActivityComplete());
  });
}

export function* callGetLastHours(action) {
  yield authenticationWrapper(function* codeBlock() {
    if (useFixtures) {
      yield delay(500);
    }
    const { hours } = action.payload;
    const res = yield fork(getHistoryFromHours, hours);
    const activities = yield join(res);
    yield put(setHistoryFromHours(hours, activities));
  });
}
export function* callStartVideoChatV2({ payload: { inviteList } }) {
  yield authenticationWrapper(
    function* codeBlock() {
      if (useFixtures) {
        yield delay(500);
      }
      const res = yield fork(getSessionIdV2, inviteList);
      const sessionId = yield join(res);

      if (!sessionId) {
        throw new Error('Video chat session creation failed');
      }

      yield put(setChatSessionIdV2(sessionId));
    },
    function* errorHandler() {
      yield put(chatSessionOpenedV2());
      yield put(openPopUp(POPUP_TYPES.ALERT, {
        titleText: 'Video chat unavailable',
        bodyText: 'Unable to start video chat right now. Please try again.',
        buttonText: 'Close',
      }));
    }
  );
}

function* watchCallsetPendingDashboardData() {
  yield takeLatest(Types.GET_PENDING_DATA, callsetPendingDashboardData);
}
function* watchCallDismissActivity() {
  yield takeLatest(Types.DISMISS_ACTIVITY, callDismissActivity);
}
function* watchCallGetLastHours() {
  yield takeLatest(Types.GET_HISTORY_FROM_HOURS, callGetLastHours);
}
function* watchCallStartVideoChatV2() {
  yield takeLatest(Types.INVITE_TO_VIDEO_CHAT_V2, callStartVideoChatV2);
}

export default function* pendingDashboardDataSaga() {
  yield all([
    fork(watchCallsetPendingDashboardData),
    fork(watchCallDismissActivity),
    fork(watchCallGetLastHours),
    fork(watchCallStartVideoChatV2),
  ]);
}
